import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useState } from 'react';

const usePassword = (withDelay = false) => {
  const [show, setShow] = useState(false);

  const Eye = useCallback(
    ({ className, ...props }) => {
      const toggle = () => {
        setShow((data) => !data);
        if (withDelay) {
          setTimeout(() => setShow(false), 3000);
        }
      };
      return (
        <button {...props} type='button' className={`btn ${className}`} onClick={toggle}>
          {show ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
        </button>
      );
    },
    [show, withDelay],
  );

  return {
    type: show ? 'text' : 'password',
    Eye,
  };
};

export default usePassword;
